module.exports = __webpack_public_path__ + "img/o2o-vip.132f4528.svg";